var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/utils/cartdrawer.js
var cartDrawer = class {
  constructor() {
    __publicField(this, "handleOutsideClick", (event) => {
      if (event.target === this.curtain)
        this.close();
    });
    this.cartDrawerElement = document.querySelector("cart-drawer");
    this.curtain = document.querySelector("#curtain");
  }
  open() {
    const desktopRecommendations = document.querySelector("#desktop-recommendations");
    this.cartDrawerElement.setAttribute("aria-hidden", "false");
    this.curtain.setAttribute("aria-hidden", "false");
    this.curtain.addEventListener("click", this.handleOutsideClick);
    setTimeout(() => {
      desktopRecommendations.setAttribute("aria-hidden", "false");
      desktopRecommendations.style.visibility = "visible";
    }, 250);
  }
  close() {
    const desktopRecommendations = document.querySelector("#desktop-recommendations");
    desktopRecommendations.setAttribute("aria-hidden", "true");
    setTimeout(() => {
      this.cartDrawerElement.setAttribute("aria-hidden", "true");
      this.curtain.setAttribute("aria-hidden", "true");
      this.curtain.removeEventListener("click", this.handleOutsideClick);
      desktopRecommendations.style.visibility = "hidden";
    }, 250);
  }
};
var cartdrawer_default = new cartDrawer();

// src/utils/get-sections.js
var getCartSectionsToRender = (includeRecommendations = true) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  const sectionConfig = [
    {
      id: "cart-items",
      section: (_a = document.querySelector("cart-drawer")) == null ? void 0 : _a.id,
      selector: "#cart-items"
    },
    {
      id: "mobile-recommendations",
      section: (_b = document.querySelector("cart-drawer")) == null ? void 0 : _b.id,
      selector: "#mobile-recommendations"
    },
    {
      id: "cartdrawer-progress",
      section: (_c = document.querySelector("cart-drawer")) == null ? void 0 : _c.id,
      selector: "#cartdrawer-progress"
    },
    {
      id: "cartdrawer-head",
      section: (_d = document.querySelector("cart-drawer")) == null ? void 0 : _d.id,
      selector: "#cartdrawer-head"
    },
    {
      id: "cart-item-counter",
      section: "cart-item-counter",
      selector: "#cart-item-counter"
    },
    {
      id: "cart-footer",
      section: (_e = document.querySelector("cart-drawer")) == null ? void 0 : _e.id,
      selector: "#cart-footer"
    },
    {
      id: "desktop-recommendations",
      section: ((_f = document.querySelector(".main-cart__inner")) == null ? void 0 : _f.id) ? (_g = document.querySelector(".main-cart__inner")) == null ? void 0 : _g.id : (_h = document.querySelector("cart-drawer")) == null ? void 0 : _h.id,
      selector: "#desktop-recommendations"
    },
    {
      id: "cart-summary-desktop",
      section: ((_i = document.querySelector(".main-cart__inner")) == null ? void 0 : _i.id) ? (_j = document.querySelector(".main-cart__inner")) == null ? void 0 : _j.id : (_k = document.querySelector("cart-drawer")) == null ? void 0 : _k.id,
      selector: "#cart-summary-desktop"
    },
    {
      id: "cart-items-desktop",
      section: ((_l = document.querySelector(".main-cart__inner")) == null ? void 0 : _l.id) ? (_m = document.querySelector(".main-cart__inner")) == null ? void 0 : _m.id : (_n = document.querySelector("cart-drawer")) == null ? void 0 : _n.id,
      selector: "#cart-items-desktop"
    }
  ];
  const filtered = includeRecommendations ? sectionConfig : sectionConfig.filter((s) => !["mobile-recommendations", "desktop-recommendations"].includes(s.id));
  return {
    sections: filtered.map((item) => item.section).filter(Boolean),
    selectors: filtered.map((item) => item.selector)
  };
};

// src/utils/section-rendering.js
var renderSections = (dom, sectionsArray) => {
  sectionsArray.forEach((section) => {
    const source = dom.querySelector(section);
    const destination = document.querySelector(section);
    if (source && destination)
      destination.outerHTML = source.outerHTML;
  });
};
var section_rendering_default = renderSections;

// src/utils/error-handler.js
var errorHandler = class {
  /**
   * lock the body to prevent scrolling.
   */
  showError(message) {
    const errorMessage = document.querySelector("#error-message");
    const errorNotification = document.querySelector("#error-notification");
    errorNotification.setAttribute("aria-hidden", "false");
    errorMessage.innerHTML = message;
    setTimeout(() => {
      this.hideError();
    }, 5e3);
  }
  /**
   * unlock the scrolling of the body.
   */
  hideError() {
    const errorNotification = document.querySelector("#error-notification");
    errorNotification.setAttribute("aria-hidden", "true");
  }
};
var error_handler_default = new errorHandler();

// src/extenders/product-form.js
var ProductForm = class extends HTMLElement {
  /**
   * @property {HTMLButtonElement} plusButton - Quantity increment button
   * @property {HTMLButtonElement} minusButton - Quantity decrement button
   * @property {HTMLInputElement} quantityField - Quantity input field
   * @property {HTMLFormElement} form - Product form element
   * @property {HTMLButtonElement} submitButton - Add to cart button
   */
  constructor() {
    super();
    this.initializeElements();
    this.bindEvents();
  }
  /**
   * Initialize DOM element references
   */
  initializeElements() {
    this.elements = {
      plusButton: this.querySelector("#plus"),
      minusButton: this.querySelector("#minus"),
      quantityField: this.querySelector("#quantity-product-form"),
      form: this.querySelector(".shopify-product-form"),
      submitButton: this.querySelector("#add-to-cart-button"),
      alternativeProduct: this.querySelector('[name="alternative-product"]')
    };
  }
  /**
   * Bind event listeners
   */
  bindEvents() {
    var _a, _b, _c;
    (_a = this.elements.plusButton) == null ? void 0 : _a.addEventListener("click", () => this.updateQuantity(1));
    (_b = this.elements.minusButton) == null ? void 0 : _b.addEventListener("click", () => this.updateQuantity(-1));
    (_c = this.elements.form) == null ? void 0 : _c.addEventListener("submit", this.handleSubmit.bind(this));
    document.addEventListener("variant-updated", () => this.initializeElements());
  }
  /**
   * Updates quantity field value
   * @param {number} change - Amount to change quantity by
   */
  updateQuantity(change) {
    const { quantityField } = this.elements;
    const currentValue = parseInt(quantityField.value);
    const maxValue = parseInt(quantityField.getAttribute("max"));
    const newValue = currentValue + change;
    if (newValue >= 1 && newValue <= maxValue) {
      quantityField.value = newValue;
    }
  }
  /**
   * Extracts and formats form properties
   * @param {Object} data - Form data object
   * @returns {Object} Formatted properties object
   */
  extractProperties(data) {
    const properties = {};
    Object.entries(data).forEach(([key, value]) => {
      if (key.includes("properties")) {
        const property = key.replace("properties[", "").replace("]", "");
        properties[property] = value;
      }
    });
    return properties;
  }
  /**
   * Prepares form data for submission
   * @param {FormData} formData - Raw form data
   * @returns {Object} Processed form data
   */
  prepareFormData(formData) {
    const data = Object.fromEntries(formData.entries());
    data.sections = getCartSectionsToRender().sections;
    if (this.elements.quantityField) {
      data.quantity = parseInt(this.elements.quantityField.value);
    }
    if (this.elements.alternativeProduct) {
      if (this.elements.alternativeProduct.checked) {
        data.id = this.elements.alternativeProduct.dataset.activeVariant;
      }
    }
    data.properties = this.extractProperties(data);
    return data;
  }
  /**
   * Handles successful form submission
   * @param {Object} responseData - Parsed cart add response
   */
  handleSuccess(responseData) {
    const parser = new DOMParser();
    const sections = getCartSectionsToRender().selectors;
    Object.entries(responseData.sections).forEach(([_, sectionData]) => {
      const dom = parser.parseFromString(sectionData, "text/html");
      section_rendering_default(dom, sections);
    });
    this.handleQuickAdd();
    cartdrawer_default.open();
    this.toggleLoadingState(false);
  }
  /**
   * Handles quick add modal if present
   */
  handleQuickAdd() {
    if (this.getAttribute("data-location") === "quick-add") {
      const modal = document.querySelector(this.getAttribute("data-reference-selector"));
      modal == null ? void 0 : modal.setAttribute("aria-hidden", "true");
    }
  }
  /**
   * Toggles loading state on submit button
   * @param {boolean} isLoading - Loading state
   */
  toggleLoadingState(isLoading) {
    var _a;
    (_a = this.elements.submitButton) == null ? void 0 : _a.setAttribute("aria-busy", isLoading.toString());
  }
  /**
   * Handles form submission
   * @param {Event} event - Submit event
   */
  async handleSubmit(event) {
    event.preventDefault();
    this.toggleLoadingState(true);
    const data = this.prepareFormData(new FormData(event.target));
    try {
      const r = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });
      const responseData = await r.json();
      if (!r.ok)
        throw new Error(responseData.message);
      this.handleSuccess(responseData);
    } catch (error) {
      error_handler_default.showError(error.message);
      this.toggleLoadingState(false);
    }
  }
};
if (!customElements.get("product-form")) {
  customElements.define("product-form", ProductForm);
}
